export default __webpack_public_path__ + "static/media/MCC.6b7f2683.png";